import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import Typography from '@mui/material/Typography';
import { useMobile } from 'src/hooks/useMobile';
import { GradientBorder } from 'src/components/gradients/GradientBorder';
import { GradientTypography } from '../../gradients/GradientTypography';

export type WaitlistToggleProps = {
  numWaitlist: number;
  toggleWaitlist: () => void;
};

export default function WaitlistToggle({
  numWaitlist,
  toggleWaitlist,
}: WaitlistToggleProps) {
  const isMobile = useMobile();
  const minWidth = isMobile ? '200px' : 'none';
  return (
    <GradientBorder
      sx={{
        borderRadius: 10,
        width: 'fit-content',
        flex: { xs: '1 1 0', md: 'none' },
      }}
    >
      <FormGroup
        sx={{
          px: { md: 10 },
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          minWidth: { minWidth },
          backgroundColor: 'background.elevation.2',
          borderRadius: 10,
        }}
      >
        <GradientTypography
          variant="h6"
          gradientColor="primary.vertical"
          sx={{
            textTransform: 'uppercase',
          }}
        >
          Waitlist
        </GradientTypography>
        <Typography variant="h6" sx={{ pl: 2 }}>
          {numWaitlist}
        </Typography>
        <Switch onChange={toggleWaitlist} />
      </FormGroup>
    </GradientBorder>
  );
}
